import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.store.currentComponent), {
    onNext: _ctx.next,
    onCloseBox: _cache[0] || (_cache[0] = () => _ctx.emit('close-box')),
    onSelectType: _ctx.handleSelect
  }, null, 40, ["onNext", "onSelectType"]))
}